import api from '@/api'

export default {
  data() {
    return {
      scanResults: null
    }
  },
  methods: {
    sendCloseMessage(error) {
      if (window.parent) {
        window.parent.postMessage(
          {
            message: 'close',
            error
          },
          '*'
        )
      }
    },
    async onScanResult(results) {
      if (!results) {
        this.sendCloseMessage()
        return
      }
      this.scanResults = results
      const eventParams = {
        eventAction: `kyc-iframe-${this.$options?.name}-${this.$store.state.embedTokenData?.document}`,
        eventCategory: `kyc-iframe-${this.$store.state.embedTokenData?.channel}`
      }
      try {
        const { data } = await api.postKycRecord({
          data: results,
          channel: this.$store.state.embedTokenData.channel,
          documentType: this.docType
        })

        if (window.parent) {
          window.parent.postMessage(
            {
              message: 'scanDone',
              result: {
                ref: data.id
              }
            },
            '*'
          )
        }

        await this.$store.dispatch('sendAnalyticsEvent', {
          ...eventParams,
          eventLabel: 'success'
        })
      } catch (e) {
        await this.$store.dispatch('sendAnalyticsEvent', {
          ...eventParams,
          eventLabel: 'error ' + e.message
        })
      }
    }
  }
}
